import './styles.css';

import { FC } from 'react';

type RichTextViewerProps = {
  value?: string;
  emptyText?: string;
  className?: string;
};

export const RichTextViewer: FC<RichTextViewerProps> = ({
  value,
  emptyText = 'Комментарий отсутствует',
  className = '',
}) => {
  if (!value) {
    return <span className="opacity-60">{emptyText}</span>;
  }

  const classes = ['rich-text-viewer', className].filter(Boolean).join(' ');

  return <div className={classes} dangerouslySetInnerHTML={{ __html: value }} />;
};
